"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EditButton = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)(_components.IconButton)((param)=>{
    let { theme } = param;
    return {
        alignItems: 'center',
        background: theme.palette.background.paper,
        color: theme.palette.common.black,
        display: 'flex',
        fontSize: '2.4rem',
        height: 40,
        justifyContent: 'center',
        position: 'absolute',
        right: theme.spacing(-1),
        top: theme.spacing(-2),
        width: 40,
        zIndex: 1
    };
});
const EditButton = (param)=>{
    let { onClick } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
        type: "button",
        variant: "text",
        onClick: onClick,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Pen, {
            fontSize: "inherit"
        })
    });
};
exports.EditButton = EditButton;
